import AbstractController from "../../../../../vendors/services/abstractController";
import ContribuicaoService from "../../../../services/contribuicao.service";
import { useState } from "react";
import ToastService from "../../../../../vendors/services/toastService";
import { Mensagem } from "../../../../shared/mensagem/Mensagem";

export default class PesquisaSatisfacaoController extends AbstractController {
  private contribuicaoService: ContribuicaoService;
  public lista: any;
  public setLista: any;
  public respostaLista: any;
  public setRespostaLista: any;
  public send: any;
  public setSend: any;

  constructor() {
    super();
    this.contribuicaoService = new ContribuicaoService();
    [this.lista, this.setLista] = useState([]);
    [this.respostaLista, this.setRespostaLista] = useState([]);
    [this.send, this.setSend] = useState(false);
  }

  init() {
    super.init();
    this.setSend(false);
    this.obterDados();
  }

  obterDados() {
    this.contribuicaoService
      .getPesquisaSatisfacao()
      .then((res: any) => {
        this.setLista(res.result);
        const lista: any = [];
        res.result.forEach((m: any) => {
          lista.push({ cdPergunta: m.cdSeqPergunta, dsResposta: "" });
        });
        this.setRespostaLista([...lista]);
      })
      .catch((err) => this.stop());
  }

  onChange(e: any) {
    let _temp = [...this.respostaLista];
    _temp = _temp.filter((f: any) => f.cdPergunta != e.cdPergunta);
    _temp.push(e);
    this.setRespostaLista([..._temp]);
  }

  validaSalvar(handle: any) {
    this.setSend(true);
    const filtered = this.respostaLista.filter(
      (f: any) => f.dsResposta == "" && f.cdPergunta != 5
    );
    if (filtered.length > 0) {
      ToastService.showWarn(Mensagem.PREENCHA_TODOS_CAMPOS);
      return false;
    }
    handle(this.respostaLista.filter((f: any) => f.dsResposta !== ""));
  }
}
